module.exports = __webpack_public_path__ + "media/images/85/CBD_facts_woman_on_bed-8cad41363a2db62d4defc39fa460e93d.jpg";